import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

// Shared by both the Enquiries and Family Enquiries tabs — same backend
// (admin-schemes-service's enquiredSchemes, differentiated by `type`), same
// sort semantics: "name" is the enquiring/primary user's name in both cases.
export type EnquiriesSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_ENQUIRIES_SORT_OPTION: EnquiriesSortOption = "newest";

const OPTIONS: SortOption<EnquiriesSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function enquiriesSortOptionLabel(option: EnquiriesSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function enquiriesSortOptionToParams(option: EnquiriesSortOption): {
  sortBy: "createdAt" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "createdAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "createdAt", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortEnquiriesPopup({
  open,
  onClose,
  title = "Sort",
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
  sortOption: EnquiriesSortOption;
  setSortOption: (option: EnquiriesSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title={title}
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
